export const DOCUMENT_STATUS =
    {
      APPROVED: 'APPROVED',
      REJECTED: 'REJECTED',
      REMOVED: 'REMOVED',
      HOLD: 'HOLD',
      WAITING: 'WAITING',
      NOTES: 'NOTES'
    };
